import { useI18n } from "../i18n";

/** 路由级 code-splitting 的加载占位。 */
export function RouteFallback() {
  const { t } = useI18n();
  return <section className="page-card placeholder-card" role="status">{t("shell.routeLoading")}</section>;
}
